import React, { useState, useEffect, useCallback } from "react";
import { useLoading } from "../../../context/LoadingContext";
import DataTable from "../../Requirement/components/common/ReusableTable";
import SearchFilter from "../../Requirement/components/common/SearchFilter";
import {
  fetchData,
  postQuery,
} from "../../Requirement/services/RequirementServices";
import {
  Typography,
  MenuItem,
  Select,
  FormControl,
  TextField,
  TextareaAutosize,
  Switch,
  FormControlLabel,
  IconButton,
  Tooltip,
} from "@mui/material";
import { Edit as EditIcon } from "@mui/icons-material";
import "../../../styles/general.css";
import "../../../styles/amtpl.css";
import AlertModal from "../../Requirement/components/common/AlerModel";
import dayjs from "dayjs";
const formatDateToMMDDYY = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString.replace(" ", "T"));
  if (isNaN(date)) return "";
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  const yy = String(date.getFullYear()).slice(-2);
  return `${mm}/${dd}/${yy}`;
};

const CreateOffersManual = () => {
  const { setLoading, loading } = useLoading();

  // Form state
  const [showForm, setShowForm] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    // Commodity Details
    productName: "",
    hsCode: "",
    grade: "",
    variety: "",
    originCountry: "",
    destinationCountry: "",
    productSpecifications: "",
    productID: "",
    // Quantity/Packaging
    quantity: "",
    packagingType: "Bags",
    packagingSize: "50kg",
    additionalPackagingNotes: "",
    // Delivery/Logistic
    shippingMethodPreference: "",
    loadingPort: "",
    dischargePort: "",
    inco: "",
    transitTime: "",
    partialDeliveryAllowed: 0,
    // Pricing/Guarantee
    pricePerMT: "",
    paymentTerms: "",
    currency: "USD",
    // Others
    specialInstructionsBuyer: "",
    internalComments: "",
    OfferStatus: "Indicative",
    OfferType: "Manual",
  });

  // Products and filters
  const [products, setProducts] = useState([]);
  const [countries, setCountries] = useState([]);
  const [productId, setProductId] = useState("");
  const [selectedPrice, setSelectedPrice] = useState([]);

  // Dynamic dropdown options
  const [packagingOptions, setPackagingOptions] = useState([]);
  const [paymentTermsOptions, setPaymentTermsOptions] = useState([]);
  const [incotermsOptions, setIncotermsOptions] = useState([]);
  const [loadingPorts, setLoadingPorts] = useState([]);
  const [dischargePorts, setDischargePorts] = useState([]);
  const [filteredPackageSizes, setFilteredPackageSizes] = useState([]);
  const [uniquePackagingTypes, setUniquePackagingTypes] = useState([]);

  // Active tab state
  const [activeTab, setActiveTab] = useState("commodityDetails");

  // Currency options
  const currencyOptions = [
    { value: "INR", label: "INR - Indian Rupee" },
    { value: "USD", label: "USD - US Dollar" },
    { value: "EUR", label: "EUR - Euro" },
    { value: "GBP", label: "GBP - British Pound" },
    { value: "JPY", label: "JPY - Japanese Yen" },
    { value: "CNY", label: "CNY - Chinese Yuan" },
  ];

  // VM Offers state
  const [vmOffersFilters, setVmOffersFilters] = useState({
    product: "",
    grade: "",
    createdDate: "",
    quantity: "",
    destinationCountry: "",
  });
  const [modal, setModal] = useState({
    show: false,
    type: "info",
    title: "",
    message: "",
    nextAction: null,
    autoClose: null,
  });
  const handleModalClose = () => {
    const action = modal.nextAction;
    setModal((prev) => ({ ...prev, show: false, nextAction: null }));
    if (action) action();
  };
  // Search fields configuration for SearchFilter component
  const fields = [
    {
      name: "product",
      label: "Product",
      type: "dropdown",
      options: [
        { value: "", label: "Select a product" },
        ...[...new Set(products.map((product) => product.ProductName))].map(
          (product) => ({
            value: product,
            label: product,
          })
        ),
      ],
      value: vmOffersFilters.product,
      onChange: (value) => {
        setVmOffersFilters((prev) => ({
          ...prev,
          product: value,
          grade: "", // Reset grade when product changes
        }));
      },
    },
    {
      name: "grade",
      label: "Grade",
      type: "dropdown",
      options: [
        { value: "", label: "Select a Grade" },
        ...products
          .filter((product) => product.ProductName === vmOffersFilters.product)
          .map((product) => ({
            value: product.Grade,
            label: product.Grade,
          })),
      ],
      value: vmOffersFilters.grade,
      onChange: (value) => {
        setVmOffersFilters((prev) => ({ ...prev, grade: value }));
      },
      disabled: !vmOffersFilters.product,
    },
    {
      name: "createdDate",
      label: "Created Date",
      type: "date",
      value: vmOffersFilters.createdDate,
      onChange: (value) => {
        setVmOffersFilters((prev) => ({ ...prev, createdDate: value }));
      },
    },
    {
      name: "quantity",
      label: "Quantity (MT)",
      type: "dropdown",
      options: [
        { value: "", label: "Select Range" },
        { value: "50-100", label: "50-100 MT" },
        { value: "100-200", label: "100-200 MT" },
        { value: "200-500", label: "200-500 MT" },
        { value: "Above-500", label: "Above 500 MT" },
      ],
      value: vmOffersFilters.quantity,
      onChange: (value) => {
        setVmOffersFilters((prev) => ({ ...prev, quantity: value }));
      },
    },
    {
      name: "destinationCountry",
      label: "Destination Country",
      type: "dropdown",
      options: [
        { value: "", label: "Select Country" },
        ...countries.map((country) => ({
          value: country.Value,
          label: country.Value,
        })),
      ],
      value: vmOffersFilters.destinationCountry,
      onChange: (value) => {
        setVmOffersFilters((prev) => ({ ...prev, destinationCountry: value }));
      },
    },
  ];

  // GP Offers state
  const [gpOffers, setGPOffers] = useState([]);
  const [selectedGPOffer, setSelectedGPOffer] = useState(null);
  const [currentGPOfferPage, setCurrentGPOfferPage] = useState(1);
  const [totalGPOfferPages, setTotalGPOfferPages] = useState(1);

  // Price calculation states
  const [sellersQuantity, setSellersQuantity] = useState(0);
  const [sellersPrice, setSellersPrice] = useState(0);
  const [sellersPriceForQuantity, setSellersPriceForQuantity] = useState(0);
  const [INRToUsd] = useState(0.012);

  // GP Offer Seller Aggregate states
  const [gpOfferSellerAggregateItems, setGpOfferSellerAggregateItems] =
    useState([]);
  const [
    selectedGPOfferSellerAggregateItem,
    setSelectedGPOfferSellerAggregateItem,
  ] = useState(null);
  const [
    currentGPOfferSellerAggregatePage,
    setCurrentGPOfferSellerAggregatePage,
  ] = useState(1);
  const [
    totalGPOfferSellerAggregatePages,
    setTotalGPOfferSellerAggregatePages,
  ] = useState(1);

  // Constants
  const pageSize = 5;

  // Define table columns for DataTable
  const columns = [
    {
      id: "OfferNumber",
      numeric: false,
      label: "Offer Number",
      renderCell: (row) => row.OfferNumber || "N/A",
    },
    // {
    //   id: "CreatedAt",
    //   numeric: false,
    //   label: "Created",
    //   renderCell: (row) => formatDateToMMDDYY(row.CreatedAt),
    // },
    // {
    //   id: "Expires",
    //   numeric: false,
    //   label: "Expires",
    //   renderCell: (row) => formatDateToMMDDYY(row.Expires),
    // },

    {
      id: "ProductName",
      numeric: false,
      label: "Product",
      renderCell: (row) => row.ProductName || "N/A",
    },
    {
      id: "Grade",
      numeric: false,
      label: "Grade",
      renderCell: (row) => row.Grade || "N/A",
    },
    {
      id: "Quantity",
      numeric: false,
      label: "Quantity",
      renderCell: (row) => formatData(row.Quantity),
    },
    {
      id: "PricePerMT",
      numeric: false,
      label: "Price",
      renderCell: (row) => formatData(row.PricePerMT),
    },
    {
      id: "DestinationCountry",
      numeric: false,
      label: "Destination",
      renderCell: (row) => row.DestinationCountry || "N/A",
    },
    {
      id: "Approved",
      numeric: false,
      label: "Approved",
      renderCell: (row) => row.Approved || "N/A",
    },
    {
      id: "CreatedAt",
      numeric: false,
      label: "Created On",
      //renderCell: (row) => formatDateToMMDDYY(row.CreatedAt),
      renderCell: (row) =>
        row.CreatedAt ? dayjs(row.CreatedAt).format("DD/MM/YYYY") : "",
    },
    {
      id: "Expires",
      numeric: false,
      label: "Expires On",
      renderCell: (row) =>
        row.Expires ? dayjs(row.Expires).format("DD/MM/YYYY") : "",
    },
    {
      id: "OfferType",
      numeric: false,
      label: "Offer Type",
      renderCell: (row) => row.OfferType || "N/A",
    },
    // {
    //   id: "GPOOfferStatus",
    //   numeric: false,
    //   label: "Offer Status",
    //   renderCell: (row) => row.GPOOfferStatus || "N/A",
    // },
    {
      id: "GPOOfferStatus",
      numeric: false,
      label: "Offer Status",
      renderCell: (row) => {
        let bgColor = "";
        let textColor = "";

        switch (row.GPOOfferStatus) {
          case "BAFO":
            bgColor = "#e0f2fe";
            textColor = "#0369a1";
            break;
          case "Firmoffer":
            bgColor = "#d1fae5";
            textColor = "#065f46";
            break;
          default:
            bgColor = "#fef3c7";
            textColor = "#b45309";
            row.GPOOfferStatus = "Indicative"; // Set default status
            break;
        }

        return (
          <span
            style={{
              backgroundColor: bgColor,
              color: textColor,
              padding: "4px 10px",
              borderRadius: "999px",
              fontSize: "0.75rem",
              fontWeight: 500,
            }}
          >
            {row.GPOOfferStatus}
          </span>
        );
      },
    },
  ];

  // Utility function to format data
  function formatData(data) {
    return data?.toLocaleString();
  }

  // Fetch products
  const fetchProducts = useCallback(async () => {
    try {
      const body = {
        target: "listProducts",
        userOrder: "ProductName",
        rowStart: 0,
        pageSize: 1000,
      };
      const result = await fetchData(body);
      if (result && result.items) {
        setProducts(result.items);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  }, []);

  // Fetch countries
  const fetchCountries = useCallback(async () => {
    try {
      const countriesData = await fetchData({
        target: "listDropDownOptions",
        userOrder: "Value",
        rowStart: 0,
        pageSize: 1000,
        filterTerms: { Type: "Country" },
      });
      setCountries(countriesData?.items || []);
    } catch (error) {
      console.error("Error fetching countries:", error);
    }
  }, []);

  // Fetch packaging options
  const fetchPackagingOptions = useCallback(async () => {
    try {
      const packagingData = await fetchData({
        target: "listDropDownOptions",
        userOrder: "Value",
        rowStart: 0,
        pageSize: 100,
        filterTerms: { Type: "packaging" },
      });
      setPackagingOptions(packagingData?.items || []);
    } catch (error) {
      console.error("Error fetching packaging options:", error);
    }
  }, []);

  // Fetch payment terms
  const fetchPaymentTerms = useCallback(async () => {
    try {
      const paymentTermsData = await fetchData({
        target: "listDropDownOptions",
        userOrder: "Value",
        rowStart: 0,
        pageSize: 1000,
        filterTerms: { Type: "paymentTerms" },
      });
      setPaymentTermsOptions(paymentTermsData?.items || []);
    } catch (error) {
      console.error("Error fetching payment terms:", error);
    }
  }, []);

  // Fetch incoterms
  const fetchIncoterms = useCallback(async () => {
    try {
      const incotermsData = await fetchData({
        target: "listDropDownOptions",
        userOrder: "Value",
        rowStart: 0,
        pageSize: 1000,
        filterTerms: { Type: "Incoterms" },
      });
      setIncotermsOptions(incotermsData?.items || []);
    } catch (error) {
      console.error("Error fetching incoterms:", error);
    }
  }, []);

  // Fetch ports based on country
  const fetchPorts = useCallback(async (country, portType) => {
    if (!country) return;
    try {
      const portsData = await fetchData({
        target: "listDropDownOptions",
        userOrder: "Value",
        rowStart: 0,
        pageSize: 500,
        filterTerms: { Type: "port", Subtype: country },
      });

      if (portType === "loading") {
        setLoadingPorts(portsData?.items || []);
      } else if (portType === "discharge") {
        setDischargePorts(portsData?.items || []);
      }
    } catch (error) {
      console.error(`Error fetching ${portType} ports:`, error);
    }
  }, []);

  // Load package sizes based on selected packaging type
  const loadPackageSizes = useCallback(
    (selectedPackaging) => {
      const filteredSizes = packagingOptions.filter(
        (item) => item.Subtype === selectedPackaging
      );
      setFilteredPackageSizes(filteredSizes);
    },
    [packagingOptions]
  );

  // Build search parameters for VM Offers
  const buildVMOffersSearchParams = (
    rowStart,
    searchValues = vmOffersFilters
  ) => {
    const filterTerms = {};

    if (searchValues.product) {
      filterTerms.product = searchValues.product;
    }
    if (searchValues.grade) {
      filterTerms.grade = searchValues.grade;
    }
    if (searchValues.destinationCountry) {
      filterTerms.DestinationCountry = searchValues.destinationCountry;
    }
    if (searchValues.createdDate instanceof Date) {
      const searchDate = searchValues.createdDate;
      const formattedDate = searchDate.toISOString().split("T")[0];
      filterTerms.CreatedAtGT = `'${formattedDate} 00:00:00'`;
      filterTerms.CreatedAtLT = `'${formattedDate} 23:59:59'`;
    } else if (searchValues.createdDate) {
      const searchDate = new Date(searchValues.createdDate);
      const formattedDate = searchDate.toISOString().split("T")[0];
      filterTerms.CreatedAtGT = `'${formattedDate} 00:00:00'`;
      filterTerms.CreatedAtLT = `'${formattedDate} 23:59:59'`;
    }
    if (searchValues.quantity) {
      const [minStr, maxStr] = searchValues.quantity.split("-");
      if (minStr === "Above") {
        const max = parseInt(maxStr, 10);
        filterTerms.QuantityGT = max;
      } else {
        const min = parseInt(minStr, 10);
        const max = parseInt(maxStr, 10);
        if (isNaN(min) || isNaN(max)) {
          // Optionally handle invalid numeric range, e.g., skip or log error
          return; // or continue without setting filters
        }
        if (min === max) {
          // Exact match when min and max are equal
          filterTerms.QuantityEQ = min;
        } else {
          filterTerms.QuantityGT = min - 1;
          filterTerms.QuantityLT = max + 1;
        }
      }
      delete filterTerms.searchValues;
    }
    return {
      filterTerms:
        Object.keys(filterTerms).length > 0 ? filterTerms : undefined,
      rowStart,
    };
  };

  // Fetch GP Offers
  const fetchGPOffers = useCallback(
    async (customParams = {}) => {
      setLoading(true);
      try {
        customParams.filterTerms = {
          ...customParams.filterTerms,
          OfferType: "Manual",
        };
        const body = {
          target: "listGPOfferAdminDetails",
          userOrder: "CreatedAt DESC, OfferSequenceID DESC",
          rowStart:
            customParams.rowStart || (currentGPOfferPage - 1) * pageSize,
          pageSize: pageSize,
          ...customParams,
        };
        body.filterTerms = body.filterTerms || {};
        body.filterTerms.AdminStatus = 1;

        const result = await fetchData(body);

        if (result && (result.items || result.statusCode === 200)) {
          const offers = result.items || [];
          setGPOffers(offers);
          setTotalGPOfferPages(
            Math.ceil((result.total || offers.length) / pageSize)
          );
        } else {
          console.error("Error fetching gpOffers: ", result);
          setGPOffers([]);
          setTotalGPOfferPages(1);
        }
      } catch (error) {
        console.error("Error fetching gpOffers: ", error);
        setGPOffers([]);
        setTotalGPOfferPages(1);
      } finally {
        setLoading(false);
      }
    },
    [currentGPOfferPage, setLoading]
  );

  // Handle page change
  const handlePageChange = (page) => {
    setCurrentGPOfferPage(page);
    const searchParams = buildVMOffersSearchParams(
      (page - 1) * pageSize,
      vmOffersFilters
    );
    fetchGPOffers(searchParams);
  };

  // Handle row click
  const handleRowClick = (offer) => {
    if (showForm) {
      setShowForm(false);
    }
    setSelectedGPOffer(offer);
    setActiveTab("offerInformation");

    // Update seller values for price calculations
    updateSellerValues(offer);
  };

  // Handle tab click
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  // Handle search for SearchFilter component
  const handleSearch = (searchValues) => {
    setVmOffersFilters(searchValues);
    setCurrentGPOfferPage(1);
    const searchParams = buildVMOffersSearchParams(0, searchValues);
    fetchGPOffers(searchParams);
  };

  // Handle form input change
  const handleFormChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));

    // Store productId when product and grade are selected
    if (field === "productName" || field === "grade") {
      const currentFormData = { ...formData, [field]: value };
      if (currentFormData.productName && currentFormData.grade) {
        const selectedProduct = products.find(
          (p) =>
            p.ProductName === currentFormData.productName &&
            p.Grade === currentFormData.grade
        );
        if (selectedProduct) {
          setProductId(selectedProduct.ProductID || selectedProduct.ID || "");
          setFormData((prev) => ({
            ...prev,
            productID: selectedProduct.ProductID || selectedProduct.ID || "",
            hsCode: selectedProduct.HsCode || "",
            variety: selectedProduct.Variety || "",
          }));
        }
      }
    }

    // Clear related port selections when country changes
    if (field === "originCountry") {
      setFormData((prev) => ({
        ...prev,
        [field]: value,
        loadingPort: "", // Clear loading port when origin country changes
      }));
      setLoadingPorts([]); // Clear current loading ports
    } else if (field === "destinationCountry") {
      setFormData((prev) => ({
        ...prev,
        [field]: value,
        dischargePort: "", // Clear discharge port when destination country changes
      }));
      setDischargePorts([]); // Clear current discharge ports
    }
  };

  // Handle packaging type change
  const handlePackagingChange = (e) => {
    const selectedPackaging = e.target.value;
    handleFormChange("packagingType", selectedPackaging);
    setFormData((prev) => ({
      ...prev,
      packagingType: selectedPackaging,
      packagingSize: "", // Reset packaging size when packaging type changes
    }));
    loadPackageSizes(selectedPackaging);
  };

  // Handle packaging size change
  const handlePackageSizeChange = (e) => {
    handleFormChange("packagingSize", e.target.value);
  };

  const handleReset = () => {
    setShowForm(false);
    setIsEditing(false);
    setSelectedGPOffer(null); // Close any selected GP Offer (product details)
    setActiveTab("commodityDetails"); // Reset to default tab
    setProductId(""); // Reset productId
    setSelectedPrice([]); // Reset selectedPrice array
    setFormData({
      productName: "",
      hsCode: "",
      grade: "",
      variety: "",
      originCountry: "",
      destinationCountry: "",
      productSpecifications: "",
      productID: "",
      quantity: "",
      packagingType: "",
      packagingSize: "50kg",
      additionalPackagingNotes: "",
      shippingMethodPreference: "",
      loadingPort: "",
      dischargePort: "",
      inco: "",
      transitTime: "",
      partialDeliveryAllowed: false,
      pricePerMT: "",
      paymentTerms: "",
      currency: "INR",
      specialInstructionsBuyer: "",
      internalComments: "",
      OfferType: "Manual",
      OfferStatus: "Indicative",
    });
    // Clear port options when form is reset
    setLoadingPorts([]);
    setDischargePorts([]);
    fetchGPOffers();
  };

  // Handle form submission
  const handleFormSubmit = async () => {
    try {
      setLoading(true);

      // Add current form data to selectedPrice array
      const updatedSelectedPrice = [...selectedPrice, formData];
      setSelectedPrice(updatedSelectedPrice);

      // Prepare the body for generateAutomaticOffers service
      const body = {
        target: "generateAutomaticOffers",
        product: productId,
        selectedPrice: updatedSelectedPrice,
      };

      console.log("Submitting offer with data:", body);

      const result = await postQuery(body);
      console.log(
        "Offer creation response:",
        result,
        result.items,
        result.items?.success
      );

      if (result && result.items?.success) {
        // alert("Offer created successfully!");
        setModal({
          show: true,
          type: "success",
          title: "Success",
          message: `Offer created successfully!`,
          autoClose: false,
        });
        await fetchGPOffers();
        handleReset(); // Reset form after successful creation
      } else {
        alert("Error creating offer: " + (result?.message || "Unknown error"));
      }
    } catch (error) {
      // console.error("Error creating offer:", error);
      // alert("Error creating offer: " + error.message);
      setModal({
        show: true,
        type: "error",
        title: "Error",
        message: `Error creating offer:` + error.message,
      });
    } finally {
      setLoading(false);
    }
  };

  // Handle edit offer - load data into form
  const handleEditOffer = (offer) => {
    // Load the offer data into the form
    setFormData({
      OfferNumber: offer.OfferNumber || "",
      GPOOfferStatus: offer.GPOOfferStatus || "",
      CreatedAt: offer.CreatedAt || "",
      Expires: offer.Expires || "",
      Approved: offer.Approved || "",
      Sellerinformation: offer.Sellerinformation || "",
      OfferType: offer.OfferType || "Manual",
      // Commodity Details
      productName: offer.ProductName || "",
      hsCode: offer.HSCode || "",
      grade: offer.Grade || "",
      variety: offer.Variety || "",
      originCountry: offer.OriginCountry || "",
      destinationCountry: offer.DestinationCountry || "",
      productSpecifications: offer.ProductSpecifications || "",
      productID: offer.ProductID || "",
      // Quantity/Packaging
      quantity: offer.Quantity || "",
      packagingType: offer.PackagingType || "",
      packagingSize: offer.PackagingSize || "",
      additionalPackagingNotes: offer.AdditionalPackagingNotes || "",
      // Delivery/Logistic
      shippingMethodPreference: offer.ShippingMethodPreference || "",
      loadingPort: offer.LoadingPort || "",
      dischargePort: offer.DischargePort || "",
      inco: offer.Incoterms || "",
      transitTime: offer.TransitTime || "",
      partialDeliveryAllowed: offer.PartialDeliveryAllowed || 0,
      // Pricing/Guarantee
      pricePerMT: offer.PricePerMT || "",
      paymentTerms: offer.PaymentTerms || "",
      currency: offer.Currency || "INR",
      // Others
      specialInstructionsBuyer: offer.SpecialInstructionsBuyer || "",
      internalComments: offer.InternalComments || "",
    });

    // Set productId if available
    if (offer.ProductID) {
      setProductId(offer.ProductID);
    } else if (offer.ProductName && offer.Grade) {
      // Try to find productId from products array
      const selectedProduct = products.find(
        (p) => p.ProductName === offer.ProductName && p.Grade === offer.Grade
      );
      if (selectedProduct) {
        setProductId(selectedProduct.ProductID || selectedProduct.ID || "");
      }
    }

    // Show the form and set to commodity details tab
    setIsEditing(true);
    setShowForm(true);
    setActiveTab("offerInformation");
    setSelectedGPOffer(null);

    // If ports need to be loaded based on countries
    if (offer.OriginCountry) {
      fetchPorts(offer.OriginCountry, "loading");
    }
    if (offer.DestinationCountry) {
      fetchPorts(offer.DestinationCountry, "discharge");
    }
  };

  // Handle GP Offer Seller Aggregate Item row click
  const handleGPOfferSellerAggregateItemRowClick = (item) => {
    setSelectedGPOfferSellerAggregateItem(item);
  };

  // Handle GP Offer Seller Aggregate page change
  const handleGPOfferSellerAggregatePageChange = (page) => {
    setCurrentGPOfferSellerAggregatePage(page);
    // Add logic to fetch new data if needed
  };

  // Update seller values when GP offer is selected
  const updateSellerValues = (gpOffer) => {
    if (gpOffer) {
      setSellersQuantity(gpOffer.Quantity || 0);
      setSellersPrice(gpOffer.PricePerMT || 0);
      setSellersPriceForQuantity(
        gpOffer.TotalPrice || gpOffer.Quantity * gpOffer.PricePerMT || 0
      );
    }
  };

  // Effect hooks
  useEffect(() => {
    fetchGPOffers();
    fetchCountries();
    fetchProducts();
    fetchPackagingOptions();
    fetchPaymentTerms();
    fetchIncoterms();
  }, [
    fetchCountries,
    fetchProducts,
    fetchPackagingOptions,
    fetchPaymentTerms,
    fetchIncoterms,
  ]);

  // Effect to fetch ports when origin country changes
  useEffect(() => {
    if (formData.originCountry) {
      fetchPorts(formData.originCountry, "loading");
    }
  }, [formData.originCountry, fetchPorts]);

  // Effect to fetch ports when destination country changes
  useEffect(() => {
    if (formData.destinationCountry) {
      fetchPorts(formData.destinationCountry, "discharge");
    }
  }, [formData.destinationCountry, fetchPorts]);

  // Effect to create unique packaging types when packaging options change
  useEffect(() => {
    if (packagingOptions.length > 0) {
      const types = [
        ...new Set(
          packagingOptions.map((option) => option.Subtype).filter(Boolean)
        ),
      ];
      setUniquePackagingTypes(types);
    }
  }, [packagingOptions]);
  const hasActiveVMOffersFilters = useCallback(() => {
    return (
      vmOffersFilters.product ||
      vmOffersFilters.grade ||
      vmOffersFilters.createdDate ||
      vmOffersFilters.quantity ||
      vmOffersFilters.destinationCountry
    );
  }, [vmOffersFilters]);
  useEffect(() => {
    const params = hasActiveVMOffersFilters()
      ? buildVMOffersSearchParams(0)
      : {};
    fetchGPOffers(params);
    setCurrentGPOfferPage(1);
  }, [vmOffersFilters, hasActiveVMOffersFilters]);
  return (
    <div className="compare-offer-container">
      <AlertModal
        type={modal.type}
        title={modal.title}
        message={modal.message}
        showModal={modal.show}
        onClose={handleModalClose}
        buttonText="OK"
        autoClose={modal.autoClose}
      />
      <div
        className="head-btn"
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px",
          alignItems: "end",
          marginRight: "12px",
        }}
      >
        <div
          className="submit-btn"
          onClick={() => {
            if (!showForm) {
              // Opening the form
              handleReset();
              setShowForm(true);
              setActiveTab("commodityDetails"); // Ensure default tab is set
            } else {
              // Closing the form
              handleReset();
              setShowForm(false);
            }
          }}
        >
          {showForm ? "Cancel" : "Add"}
        </div>
      </div>
      <div className="search-filter4">
        <div className="title4">
          <div className="head-text">Create Offers Manual</div>
        </div>
        <div className="filter4">
          <SearchFilter fields={fields} onSearch={handleSearch} />
        </div>
      </div>

      <div className="row main-row">
        <section className="offers">
          {loading && <div className="loading">Loading offers...</div>}
          {!loading && gpOffers.length === 0 && (
            <div className="empty-state">No Offers available</div>
          )}
          {!loading && gpOffers.length > 0 && (
            <DataTable
              columns={columns}
              data={gpOffers}
              total={totalGPOfferPages * pageSize}
              title="GP Offers Information"
              rowsPerPage={pageSize}
              onPageChange={handlePageChange}
              onRowClick={handleRowClick}
              currentPage={currentGPOfferPage}
              selectedRows={
                selectedGPOffer
                  ? [selectedGPOffer.GPOfferID || selectedGPOffer.id]
                  : []
              }
            />
          )}
        </section>
      </div>

      {showForm && (
        <>
          <div className="row">
            <section className="product-details-offers">
              {/* Submit and Cancel buttons positioned above tabs */}
              <div className="row" style={{ marginBottom: "20px" }}>
                <div className="col-lg-12 text-end">
                  <button
                    type="button"
                    className="submit-btn"
                    onClick={() => setShowForm(false)}
                    disabled={loading}
                  >
                    CANCEL
                  </button>
                  <button
                    type="button"
                    className="submit-btn"
                    onClick={handleFormSubmit}
                    disabled={loading}
                    style={{
                      marginLeft: "5px",
                    }}
                  >
                    {loading ? "SUBMITTING..." : "SUBMIT"}
                  </button>
                </div>
              </div>

              <div className="tabs">
                {isEditing && (
                  <button
                    className={activeTab === "offerInformation" ? "active" : ""}
                    onClick={() => handleTabClick("offerInformation")}
                  >
                    Offer Information
                  </button>
                )}
                <button
                  className={activeTab === "commodityDetails" ? "active" : ""}
                  onClick={() => handleTabClick("commodityDetails")}
                >
                  Commodity Details
                </button>
                <button
                  className={activeTab === "specifications" ? "active" : ""}
                  onClick={() => handleTabClick("specifications")}
                >
                  Specifications
                </button>
                <button
                  className={activeTab === "quantityPackaging" ? "active" : ""}
                  onClick={() => handleTabClick("quantityPackaging")}
                >
                  Quantity/Packaging
                </button>
                <button
                  className={activeTab === "deliveryLogistic" ? "active" : ""}
                  onClick={() => handleTabClick("deliveryLogistic")}
                >
                  Delivery/Logistic
                </button>
                <button
                  className={activeTab === "pricing" ? "active" : ""}
                  onClick={() => handleTabClick("pricing")}
                >
                  Pricing/Guarantee
                </button>
                <button
                  className={activeTab === "others" ? "active" : ""}
                  onClick={() => handleTabClick("others")}
                >
                  Others
                </button>
              </div>

              {isEditing && activeTab === "offerInformation" && (
                <div className="tab-content active">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="row">
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="offerSequenceID">Offer Number</label>
                          <input
                            id="offerSequenceID"
                            type="text"
                            value={formData?.OfferNumber || ""}
                            className="form-control"
                            readOnly
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="offerStatus">Offer Status</label>
                          <input
                            id="offerStatus"
                            type="text"
                            value={formData?.GPOOfferStatus || "Indicative"}
                            className="form-control"
                            readOnly
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="createdAt">Creation Date</label>
                          <input
                            id="createdAt"
                            type="text"
                            value={formatDateToMMDDYY(formData?.CreatedAt)}
                            className="form-control"
                            readOnly
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="expires">Expiry Date</label>
                          <input
                            id="expires"
                            type="text"
                            value={formatDateToMMDDYY(formData?.Expires)}
                            className="form-control"
                            readOnly
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="offerType">Offer Type</label>
                          <input
                            id="offerType"
                            type="text"
                            value={formData?.OfferType || "Manual"}
                            className="form-control"
                            readOnly
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="approved">Approved</label>
                          <input
                            id="approved"
                            type="text"
                            value={formData?.Approved || ""}
                            className="form-control"
                            readOnly
                          />
                        </div>
                        <div className="col-lg-6 col-sm-8 col-12">
                          <label htmlFor="sellerInformation">
                            Seller Information
                          </label>
                          <input
                            id="sellerInformation"
                            type="text"
                            value={formData?.Sellerinformation || "AMTPL"}
                            className="form-control"
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {activeTab === "commodityDetails" && (
                <div className="tab-content active">
                  <div className="row g-3">
                    <div className="col-md-6">
                      <FormControl sx={{ minWidth: "100%" }}>
                        <Typography variant="body2">Product *</Typography>
                        <Select
                          value={formData.productName}
                          onChange={(e) =>
                            handleFormChange("productName", e.target.value)
                          }
                          displayEmpty
                          sx={{ backgroundColor: "white" }}
                        >
                          <MenuItem value="" disabled>
                            Select Product
                          </MenuItem>
                          {[...new Set(products.map((p) => p.ProductName))].map(
                            (productName) => (
                              <MenuItem key={productName} value={productName}>
                                {productName}
                              </MenuItem>
                            )
                          )}
                        </Select>
                      </FormControl>
                    </div>
                    <div className="col-md-6">
                      <Typography variant="body2">HS Code</Typography>
                      <TextField
                        value={formData.hsCode}
                        onChange={(e) =>
                          handleFormChange("hsCode", e.target.value)
                        }
                        sx={{ backgroundColor: "white", width: "100%" }}
                        placeholder="Enter HS Code"
                        disabled={true}
                      />
                    </div>
                    <div className="col-md-4">
                      <FormControl sx={{ minWidth: "100%" }}>
                        <Typography variant="body2">
                          Grade / Quality *
                        </Typography>
                        <Select
                          value={formData.grade}
                          onChange={(e) =>
                            handleFormChange("grade", e.target.value)
                          }
                          displayEmpty
                          sx={{ backgroundColor: "white" }}
                        >
                          <MenuItem value="" disabled>
                            Select Grade
                          </MenuItem>
                          {products
                            .filter(
                              (p) => p.ProductName === formData.productName
                            )
                            .map((product) => (
                              <MenuItem
                                key={product.Grade}
                                value={product.Grade}
                              >
                                {product.Grade}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    </div>
                    <div className="col-md-4">
                      <Typography variant="body2">Variety</Typography>
                      <TextField
                        value={formData.variety}
                        onChange={(e) =>
                          handleFormChange("variety", e.target.value)
                        }
                        sx={{ backgroundColor: "white", width: "100%" }}
                        placeholder="Enter Variety"
                        disabled={true}
                      />
                    </div>
                    <div className="col-md-4">
                      <FormControl sx={{ minWidth: "100%" }}>
                        <Typography variant="body2">Origin Country</Typography>
                        <Select
                          value={formData.originCountry}
                          onChange={(e) =>
                            handleFormChange("originCountry", e.target.value)
                          }
                          displayEmpty
                          sx={{ backgroundColor: "white" }}
                        >
                          <MenuItem value="" disabled>
                            Select Origin Country
                          </MenuItem>
                          {countries.map((country) => (
                            <MenuItem key={country.Value} value={country.Value}>
                              {country.Value}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                    <div className="col-md-6">
                      <FormControl sx={{ minWidth: "100%" }}>
                        <Typography variant="body2">
                          Destination Country
                        </Typography>
                        <Select
                          value={formData.destinationCountry}
                          onChange={(e) =>
                            handleFormChange(
                              "destinationCountry",
                              e.target.value
                            )
                          }
                          displayEmpty
                          sx={{ backgroundColor: "white" }}
                        >
                          <MenuItem value="" disabled>
                            Select Destination Country
                          </MenuItem>
                          {countries.map((country) => (
                            <MenuItem key={country.Value} value={country.Value}>
                              {country.Value}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                </div>
              )}

              {activeTab === "specifications" && (
                <div className="tab-content active">
                  <div className="row g-3">
                    <div className="col-md-12">
                      <Typography variant="body2">
                        Product Specifications
                      </Typography>
                      <TextareaAutosize
                        value={formData.productSpecifications}
                        onChange={(e) =>
                          handleFormChange(
                            "productSpecifications",
                            e.target.value
                          )
                        }
                        style={{
                          width: "100%",
                          minHeight: "200px",
                          backgroundColor: "white",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          padding: "8px",
                          fontFamily: "inherit",
                          fontSize: "14px",
                          resize: "vertical",
                        }}
                        placeholder="Enter Product Specifications"
                      />
                    </div>
                  </div>
                </div>
              )}

              {activeTab === "quantityPackaging" && (
                <div className="tab-content active">
                  <div className="row g-3">
                    <div className="col-md-6">
                      <Typography variant="body2">Quantity (MT) *</Typography>
                      <TextField
                        type="number"
                        value={formData.quantity}
                        onChange={(e) =>
                          handleFormChange("quantity", e.target.value)
                        }
                        sx={{ backgroundColor: "white", width: "100%" }}
                        placeholder="Enter Quantity in MT"
                      />
                    </div>
                    <div className="col-md-6">
                      <FormControl sx={{ minWidth: "100%" }}>
                        <Typography variant="body2">
                          Packaging Type *
                        </Typography>
                        <Select
                          value={formData.packagingType}
                          onChange={handlePackagingChange}
                          displayEmpty
                          sx={{ backgroundColor: "white" }}
                        >
                          <MenuItem value="" disabled>
                            Select Packaging Type
                          </MenuItem>
                          {uniquePackagingTypes.map((type) => (
                            <MenuItem key={type} value={type}>
                              {type}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                    <div className="col-md-6">
                      <FormControl sx={{ minWidth: "100%" }}>
                        <Typography variant="body2">Packaging Size</Typography>
                        <Select
                          value={formData.packagingSize}
                          onChange={handlePackageSizeChange}
                          disabled={!formData.packagingType}
                          displayEmpty
                          sx={{ backgroundColor: "white" }}
                        >
                          <MenuItem value="" disabled>
                            {!formData.packagingType
                              ? "Select Packaging Type first"
                              : "Select Packaging Size"}
                          </MenuItem>
                          {filteredPackageSizes.map((size) => (
                            <MenuItem key={size.Value} value={size.Value}>
                              {size.Value}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                    <div className="col-md-12">
                      <Typography variant="body2">
                        Additional Packaging Notes
                      </Typography>
                      <TextareaAutosize
                        value={formData.additionalPackagingNotes}
                        onChange={(e) =>
                          handleFormChange(
                            "additionalPackagingNotes",
                            e.target.value
                          )
                        }
                        style={{
                          width: "100%",
                          minHeight: "80px",
                          backgroundColor: "white",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          padding: "8px",
                          fontFamily: "inherit",
                          fontSize: "14px",
                          resize: "vertical",
                        }}
                        placeholder="Enter Additional Packaging Notes"
                      />
                    </div>
                  </div>
                </div>
              )}

              {activeTab === "deliveryLogistic" && (
                <div className="tab-content active">
                  <div className="row g-3">
                    <div className="col-md-6">
                      <FormControl sx={{ minWidth: "100%" }}>
                        <Typography variant="body2">Shipping Method</Typography>
                        <Select
                          value={formData.shippingMethodPreference}
                          onChange={(e) =>
                            handleFormChange(
                              "shippingMethodPreference",
                              e.target.value
                            )
                          }
                          displayEmpty
                          sx={{ backgroundColor: "white" }}
                        >
                          <MenuItem value="" disabled>
                            Select Shipping Method
                          </MenuItem>
                          <MenuItem value="Road">Road</MenuItem>
                          <MenuItem value="Rail">Rail</MenuItem>
                          <MenuItem value="Ocean">Ocean</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                    <div className="col-md-6">
                      <FormControl sx={{ minWidth: "100%" }}>
                        <Typography variant="body2">Port of Loading</Typography>
                        <Select
                          value={formData.loadingPort}
                          onChange={(e) =>
                            handleFormChange("loadingPort", e.target.value)
                          }
                          displayEmpty
                          sx={{ backgroundColor: "white" }}
                          disabled={!formData.originCountry}
                        >
                          <MenuItem value="" disabled>
                            {formData.originCountry
                              ? "Select Port of Loading"
                              : "Select Origin Country first"}
                          </MenuItem>
                          {loadingPorts.map((port) => (
                            <MenuItem key={port.Value} value={port.Value}>
                              {port.Value}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                    <div className="col-md-6">
                      <FormControl sx={{ minWidth: "100%" }}>
                        <Typography variant="body2">
                          Port of Destination
                        </Typography>
                        <Select
                          value={formData.dischargePort}
                          onChange={(e) =>
                            handleFormChange("dischargePort", e.target.value)
                          }
                          displayEmpty
                          sx={{ backgroundColor: "white" }}
                          disabled={!formData.destinationCountry}
                        >
                          <MenuItem value="" disabled>
                            {formData.destinationCountry
                              ? "Select Port of Destination"
                              : "Select Destination Country first"}
                          </MenuItem>
                          {dischargePorts.map((port) => (
                            <MenuItem key={port.Value} value={port.Value}>
                              {port.Value}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                    <div className="col-md-6">
                      <FormControl sx={{ minWidth: "100%" }}>
                        <Typography variant="body2">Incoterms</Typography>
                        <Select
                          value={formData.inco}
                          onChange={(e) =>
                            handleFormChange("inco", e.target.value)
                          }
                          displayEmpty
                          sx={{ backgroundColor: "white" }}
                        >
                          <MenuItem value="" disabled>
                            Select Incoterms
                          </MenuItem>
                          {incotermsOptions.map((incoterm) => (
                            <MenuItem
                              key={incoterm.Value}
                              value={incoterm.Value}
                            >
                              {incoterm.Value}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                    <div className="col-md-4">
                      <Typography variant="body2">Transit Time</Typography>
                      <TextField
                        value={formData.transitTime}
                        onChange={(e) =>
                          handleFormChange("transitTime", e.target.value)
                        }
                        sx={{ backgroundColor: "white", width: "100%" }}
                        placeholder="Enter Transit Time"
                      />
                    </div>
                    <div className="col-md-4">
                      <FormControlLabel
                        control={
                          <Switch
                            checked={formData.partialDeliveryAllowed === 1}
                            onChange={(e) =>
                              handleFormChange(
                                "partialDeliveryAllowed",
                                e.target.checked ? 1 : 0
                              )
                            }
                            color="primary"
                          />
                        }
                        label="Partial Delivery Allowed"
                        sx={{
                          marginTop: "24px",
                          "& .MuiSwitch-switchBase.Mui-checked": {
                            color: "#fd7e14", // Orange thumb when checked
                          },
                          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                            {
                              backgroundColor: "#fd7e14", // Orange track when checked
                            },
                          "& .MuiSwitch-track": {
                            backgroundColor: "#f0f0f0", // Gray track when unchecked
                          },
                        }}
                      />
                    </div>
                    <div className="col-md-4"></div>
                    <div className="col-md-4"></div>
                  </div>
                </div>
              )}

              {activeTab === "pricing" && (
                <div className="tab-content active">
                  <div className="row g-3">
                    <div className="col-md-6">
                      <Typography variant="body2">Price per MT *</Typography>
                      <TextField
                        type="number"
                        value={formData.pricePerMT}
                        onChange={(e) =>
                          handleFormChange("pricePerMT", e.target.value)
                        }
                        sx={{ backgroundColor: "white", width: "100%" }}
                        placeholder="Enter Price per MT"
                      />
                    </div>
                    <div className="col-md-6">
                      <FormControl sx={{ minWidth: "100%" }}>
                        <Typography variant="body2">Currency *</Typography>
                        <Select
                          value={formData.currency}
                          onChange={(e) =>
                            handleFormChange("currency", e.target.value)
                          }
                          displayEmpty
                          sx={{ backgroundColor: "white" }}
                        >
                          <MenuItem value="" disabled>
                            Select Currency
                          </MenuItem>
                          {currencyOptions.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                    <div className="col-md-6">
                      <FormControl sx={{ minWidth: "100%" }}>
                        <Typography variant="body2">Payment Terms</Typography>
                        <Select
                          value={formData.paymentTerms}
                          onChange={(e) =>
                            handleFormChange("paymentTerms", e.target.value)
                          }
                          displayEmpty
                          sx={{ backgroundColor: "white" }}
                        >
                          <MenuItem value="" disabled>
                            Select Payment Terms
                          </MenuItem>
                          {paymentTermsOptions.map((paymentTerm) => (
                            <MenuItem
                              key={paymentTerm.Value}
                              value={paymentTerm.Value}
                            >
                              {paymentTerm.Value}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                </div>
              )}

              {activeTab === "others" && (
                <div className="tab-content active">
                  <div className="row g-3">
                    <div className="col-md-12">
                      <Typography variant="body2">
                        Special Instructions for Buyer
                      </Typography>
                      <TextareaAutosize
                        value={formData.specialInstructionsBuyer}
                        onChange={(e) =>
                          handleFormChange(
                            "specialInstructionsBuyer",
                            e.target.value
                          )
                        }
                        style={{
                          width: "100%",
                          minHeight: "120px",
                          backgroundColor: "white",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          padding: "8px",
                          fontFamily: "inherit",
                          fontSize: "14px",
                          resize: "vertical",
                        }}
                        placeholder="Enter Special Instructions for Buyer"
                      />
                    </div>
                    <div className="col-md-12">
                      <Typography variant="body2">Internal Comments</Typography>
                      <TextareaAutosize
                        value={formData.internalComments}
                        onChange={(e) =>
                          handleFormChange("internalComments", e.target.value)
                        }
                        style={{
                          width: "100%",
                          minHeight: "120px",
                          backgroundColor: "white",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          padding: "8px",
                          fontFamily: "inherit",
                          fontSize: "14px",
                          resize: "vertical",
                        }}
                        placeholder="Enter Internal Comments"
                      />
                    </div>
                  </div>
                </div>
              )}
            </section>
          </div>
        </>
      )}

      {!showForm && selectedGPOffer && (
        <>
          <div className="row">
            <section className="product-details">
              <div className="tabs">
                <button
                  className={activeTab === "offerInformation" ? "active" : ""}
                  onClick={() => handleTabClick("offerInformation")}
                >
                  Offer Information
                </button>
                <button
                  className={activeTab === "commodityDetails" ? "active" : ""}
                  onClick={() => handleTabClick("commodityDetails")}
                >
                  Commodity Details
                </button>
                <button
                  className={activeTab === "quantityPackaging" ? "active" : ""}
                  onClick={() => handleTabClick("quantityPackaging")}
                >
                  Quantity/Packaging
                </button>
                <button
                  className={activeTab === "deliveryLogistic" ? "active" : ""}
                  onClick={() => handleTabClick("deliveryLogistic")}
                >
                  Delivery/Logistic
                </button>
                <button
                  className={activeTab === "pricing" ? "active" : ""}
                  onClick={() => handleTabClick("pricing")}
                >
                  Pricing/Guarantee
                </button>
                <button
                  className={activeTab === "priceBreakup" ? "active" : ""}
                  onClick={() => handleTabClick("priceBreakup")}
                >
                  Price Breakup
                </button>

                <button
                  className={activeTab === "others" ? "active" : ""}
                  onClick={() => handleTabClick("others")}
                >
                  Others
                </button>
              </div>

              {(activeTab === null || activeTab === "offerInformation") && (
                <div className="tab-content active">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="row">
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="offerSequenceID">Offer Number</label>
                          <input
                            id="offerSequenceID"
                            type="text"
                            value={selectedGPOffer?.OfferNumber || ""}
                            className="form-control"
                            readOnly
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="offerStatus">Offer Status</label>
                          <input
                            id="offerStatus"
                            type="text"
                            value={
                              selectedGPOffer?.GPOOfferStatus || "Indicative"
                            }
                            className="form-control"
                            readOnly
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="createdAt">Creation Date</label>
                          <input
                            id="createdAt"
                            type="text"
                            value={formatDateToMMDDYY(
                              selectedGPOffer?.CreatedAt
                            )}
                            className="form-control"
                            readOnly
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="expires">Expiry Date</label>
                          <input
                            id="expires"
                            type="text"
                            value={formatDateToMMDDYY(selectedGPOffer?.Expires)}
                            className="form-control"
                            readOnly
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="offerType">Offer Type</label>
                          <input
                            id="offerType"
                            type="text"
                            value={selectedGPOffer?.OfferType || "Manual"}
                            className="form-control"
                            readOnly
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="approved">Approved</label>
                          <input
                            id="approved"
                            type="text"
                            value={selectedGPOffer?.Approved || ""}
                            className="form-control"
                            readOnly
                          />
                        </div>
                        <div className="col-lg-6 col-sm-8 col-12">
                          <label htmlFor="sellerInformation">
                            Seller Information
                          </label>
                          <input
                            id="sellerInformation"
                            type="text"
                            value={
                              selectedGPOffer?.Sellerinformation || "AMTPL"
                            }
                            className="form-control"
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {activeTab === "commodityDetails" && (
                <div className="tab-content active">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="row">
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="productName">Product</label>
                          <input
                            id="productName"
                            type="text"
                            value={selectedGPOffer?.ProductName || ""}
                            className="form-control"
                            readOnly
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="hsCode">HS Code</label>
                          <input
                            id="hsCode"
                            type="text"
                            value={selectedGPOffer?.HsCode || ""}
                            className="form-control"
                            readOnly
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="grade">Grade / Quality</label>
                          <input
                            id="grade"
                            type="text"
                            value={selectedGPOffer?.Grade || ""}
                            className="form-control"
                            readOnly
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="variety">Variety</label>
                          <input
                            id="variety"
                            type="text"
                            value={selectedGPOffer?.Variety || ""}
                            className="form-control"
                            readOnly
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="originCountry">Origin Country</label>
                          <input
                            id="originCountry"
                            type="text"
                            value={selectedGPOffer?.OriginCountry || ""}
                            className="form-control"
                            readOnly
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="destinationCountry">
                            Destination Country
                          </label>
                          <input
                            id="destinationCountry"
                            type="text"
                            value={selectedGPOffer?.DestinationCountry || ""}
                            className="form-control"
                            readOnly
                          />
                        </div>
                        <div className="col-lg-6 col-sm-8 col-12">
                          <label htmlFor="productSpecifications">
                            Product Specifications
                          </label>
                          <textarea
                            id="productSpecifications"
                            className="form-control"
                            rows="4"
                            value={selectedGPOffer?.ProductSpecifications || ""}
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {activeTab === "quantityPackaging" && (
                <div className="tab-content active">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="row">
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="quantity">Quantity (MT)</label>
                          <input
                            id="quantity"
                            type="text"
                            value={formatData(selectedGPOffer?.Quantity)}
                            className="form-control"
                            readOnly
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="packagingType">Packaging Type</label>
                          <input
                            id="packagingType"
                            type="text"
                            value={selectedGPOffer?.PackagingType || "Bags"}
                            className="form-control"
                            readOnly
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="packagingSize">Packaging Size</label>
                          <input
                            id="packagingSize"
                            type="text"
                            value={selectedGPOffer?.PackagingSize || "50kg"}
                            className="form-control"
                            readOnly
                          />
                        </div>
                        <div className="col-lg-9 col-sm-8 col-12">
                          <label htmlFor="additionalPackagingNotes">
                            Additional Packaging Notes
                          </label>
                          <textarea
                            id="additionalPackagingNotes"
                            value={
                              selectedGPOffer?.AdditionalPackagingNotes || ""
                            }
                            className="form-control"
                            readOnly
                            rows="3"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {activeTab === "deliveryLogistic" && (
                <div className="tab-content active">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="row">
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="shippingMethod">
                            Shipping Method
                          </label>
                          <input
                            id="shippingMethod"
                            type="text"
                            value={
                              selectedGPOffer?.ShippingMethodPreference || ""
                            }
                            className="form-control"
                            readOnly
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="portOfLoading">Port of Loading</label>
                          <input
                            id="portOfLoading"
                            type="text"
                            value={selectedGPOffer?.LoadingPort || ""}
                            className="form-control"
                            readOnly
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="portOfDestination">
                            Port of Destination
                          </label>
                          <input
                            id="portOfDestination"
                            type="text"
                            value={selectedGPOffer?.DischargePort || ""}
                            className="form-control"
                            readOnly
                          />
                        </div>

                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="portOfDestination">Incoterms</label>
                          <input
                            id="Incoterms"
                            type="text"
                            value={selectedGPOffer?.INCO || ""}
                            className="form-control"
                            readOnly
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="TransitTime">Transit Time</label>
                          <input
                            id="TransitTime"
                            type="text"
                            value={selectedGPOffer?.TransitTime || ""}
                            className="form-control"
                            readOnly
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="PartialDeliveryAllowed">
                            Partial Delivery Allowed?
                          </label>
                          <input
                            id="PartialDeliveryAllowed"
                            type="text"
                            value={
                              selectedGPOffer?.PartialDeliveryAllowed
                                ? "Yes"
                                : "No"
                            }
                            className="form-control"
                            readOnly
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="DailyUnloadingCapacity">
                            Daily Unloading Capacity
                          </label>
                          <input
                            id="DailyUnloadingCapacity"
                            type="text"
                            value={
                              selectedGPOffer?.DailyUnloadingCapacity
                                ? "Yes"
                                : "No"
                            }
                            className="form-control"
                            readOnly
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="UnloadingResponsibility">
                            Unloading Responsibility
                          </label>
                          <input
                            id="UnloadingResponsibility"
                            type="text"
                            value={
                              selectedGPOffer?.UnloadingResponsibility || ""
                            }
                            className="form-control"
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {activeTab === "pricing" && (
                <div className="tab-content active">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="row">
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="fobSalePrice">
                            FOB Sale Price - Total (INR)
                          </label>
                          <input
                            id="fobSalePrice"
                            type="text"
                            value={formatData(selectedGPOffer?.FOBSalePrice)}
                            className="form-control"
                            readOnly
                          />
                        </div>

                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="fobSalePrice">
                            FOB Sale Price - Total (USD)
                          </label>
                          <input
                            id="fobSalePrice"
                            type="text"
                            value={formatData(
                              selectedGPOffer?.FOBSalePrice * INRToUsd
                            )}
                            className="form-control"
                            readOnly
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="fobSalePrice">
                            FOB Sale Price (INR/MT)
                          </label>
                          <input
                            id="fobSalePrice"
                            type="text"
                            value={formatData(
                              selectedGPOffer?.FOBSalePrice /
                                selectedGPOffer?.Quantity
                            )}
                            className="form-control"
                            readOnly
                          />
                        </div>

                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="fobSalePrice">
                            FOB Sale Price (USD/MT)
                          </label>
                          <input
                            id="fobSalePrice"
                            type="text"
                            value={formatData(
                              (selectedGPOffer?.FOBSalePrice /
                                selectedGPOffer?.Quantity) *
                                INRToUsd
                            )}
                            className="form-control"
                            readOnly
                          />
                        </div>

                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="cifSalePrice">
                            CIF Sale Price - Total (INR)
                          </label>
                          <input
                            id="cifSalePrice"
                            type="text"
                            value={formatData(selectedGPOffer?.CIFSalePrice)}
                            className="form-control"
                            readOnly
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="cifSalePrice">
                            CIF Sale Price - Total (USD)
                          </label>
                          <input
                            id="cifSalePrice"
                            type="text"
                            value={formatData(
                              selectedGPOffer?.CIFSalePrice * INRToUsd
                            )}
                            className="form-control"
                            readOnly
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="cifSalePrice">
                            CIF Sale Price (INR/MT)
                          </label>
                          <input
                            id="cifSalePrice"
                            type="text"
                            value={formatData(
                              selectedGPOffer?.CIFSalePrice /
                                selectedGPOffer?.Quantity
                            )}
                            className="form-control"
                            readOnly
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="cifSalePrice">
                            CIF Sale Price (USD/MT)
                          </label>
                          <input
                            id="cifSalePrice"
                            type="text"
                            value={formatData(
                              (selectedGPOffer?.CIFSalePrice /
                                selectedGPOffer?.Quantity) *
                                INRToUsd
                            )}
                            className="form-control"
                            readOnly
                          />
                        </div>

                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="paymentTerms">Payment Terms</label>
                          <input
                            id="paymentTerms"
                            type="text"
                            value={selectedGPOffer?.PaymentTerms || ""}
                            className="form-control"
                            readOnly
                          />
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                          <label htmlFor="paymentMethod">Payment Method</label>
                          <input
                            id="paymentMethod"
                            type="text"
                            value={
                              selectedGPOffer?.PreferredPaymentMethod || ""
                            }
                            className="form-control"
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {activeTab === "priceBreakup" && (
                <div className="tab-content active">
                  <div className="row">
                    <div className="col-lg-12">
                      <table className="datatable">
                        <tr className="dataheader">
                          <th colSpan="1">Pricing Item</th>
                          <th rowSpan="1">Pricing Component</th>
                          <th rowSpan="1">Amount (Rs)</th>
                          <th rowSpan="1">Amount (USD)</th>
                        </tr>
                        <tr className="primerow">
                          <td>Seller's Quantity (MT)</td>
                          <td className="currency right">
                            {formatData(sellersQuantity)}
                          </td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr className="altrow">
                          <td>Seller's Price /MT (Rs.)</td>
                          <td className="currency right">
                            {formatData(sellersPrice)}
                          </td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr className="primerow">
                          <td>Seller's Total Price</td>
                          <td></td>
                          <td className="currency right">
                            {formatData(sellersPriceForQuantity)}
                          </td>
                          <td className="currency right">
                            {formatData(sellersPriceForQuantity * INRToUsd)}
                          </td>
                        </tr>
                        <tr className="altrow">
                          <td>AgroPreneur's Charges</td>
                          <td className="currency right">
                            {formatData(
                              selectedGPOffer?.APCommissionPercentage
                            )}
                            %
                          </td>
                          <td className="currency right">
                            {formatData(selectedGPOffer?.APCommission)}
                          </td>
                          <td className="currency right">
                            {formatData(
                              selectedGPOffer?.APCommission * INRToUsd
                            )}
                          </td>
                        </tr>
                        <tr className="primerow">
                          <td>Sorting & Grading Charges</td>
                          <td className="currency right">
                            {formatData(
                              selectedGPOffer?.SortGradeChargedPercentage
                            )}
                            %
                          </td>
                          <td className="currency right">
                            {formatData(selectedGPOffer?.SortGradeCharged)}
                          </td>
                          <td className="currency right">
                            {formatData(
                              selectedGPOffer?.SortGradeCharged * INRToUsd
                            )}
                          </td>
                        </tr>
                        <tr className="altrow">
                          <td>Operations & Finance Charges</td>
                          <td className="currency right">
                            {formatData(
                              selectedGPOffer?.OpsFinChargesPercentage
                            )}
                            %
                          </td>
                          <td className="currency right">
                            {formatData(selectedGPOffer?.OpsFinCharges)}
                          </td>
                          <td className="currency right">
                            {formatData(
                              selectedGPOffer?.OpsFinCharges * INRToUsd
                            )}
                          </td>
                        </tr>
                        <tr className="altrow">
                          <td>Inland Transport Charges</td>
                          <td className="currency right">
                            {selectedGPOffer?.InlandTransport
                              ? formatData(
                                  selectedGPOffer?.InlandTransport /
                                    sellersQuantity
                                )
                              : 0}
                          </td>
                          <td className="currency right">
                            {formatData(selectedGPOffer?.InlandTransport)}
                          </td>
                          <td className="currency right">
                            {formatData(
                              selectedGPOffer?.InlandTransport * INRToUsd
                            )}
                          </td>
                        </tr>
                        <tr className="primerow bold-font">
                          <td>Seller's BASE Price</td>
                          <td></td>
                          <td className="currency right">
                            {formatData(selectedGPOffer?.BasePrice)}
                          </td>
                          <td className="currency right">
                            {formatData(selectedGPOffer?.BasePrice * INRToUsd)}
                          </td>
                        </tr>
                        <tr className="altrow">
                          <td>Margin</td>
                          <td className="currency right">
                            {formatData(selectedGPOffer?.MarginPercentage)}%
                          </td>
                          <td className="currency right">
                            {formatData(selectedGPOffer?.Margin)}
                          </td>
                          <td className="currency right">
                            {formatData(selectedGPOffer?.Margin * INRToUsd)}
                          </td>
                        </tr>
                        <tr className="primerow bold-font">
                          <td>FOB Sale Price</td>
                          <td></td>
                          <td className="currency right">
                            {formatData(selectedGPOffer?.FOBSalePrice)}
                          </td>
                          <td className="currency right">
                            {formatData(
                              selectedGPOffer?.FOBSalePrice * INRToUsd
                            )}
                          </td>
                        </tr>
                        <tr className="altrow">
                          <td>Export Duty</td>
                          <td className="currency right">
                            {formatData(selectedGPOffer?.ExportDutyPercentage)}%
                          </td>
                          <td className="currency right">
                            {formatData(selectedGPOffer?.ExportDuty)}
                          </td>
                          <td className="currency right">
                            {formatData(selectedGPOffer?.ExportDuty * INRToUsd)}
                          </td>
                        </tr>
                        <tr className="altrow">
                          <td>Shipping & Insurance</td>
                          <td className="currency right">
                            Rs.{" "}
                            {formatData(
                              selectedGPOffer?.ShippingInsurancePercentage
                            )}{" "}
                            / MT
                          </td>
                          <td className="currency right">
                            {formatData(selectedGPOffer?.ShippingInsurance)}
                          </td>
                          <td className="currency right">
                            {formatData(
                              selectedGPOffer?.ShippingInsurance * INRToUsd
                            )}
                          </td>
                        </tr>
                        <tr className="altrow">
                          <td>GST (Local Taxes)</td>
                          <td></td>
                          <td className="currency right">
                            {formatData(selectedGPOffer?.GST)}
                          </td>
                          <td className="currency right">
                            {formatData(selectedGPOffer?.GST * INRToUsd)}
                          </td>
                        </tr>
                        <tr className="primerow bold-font">
                          <td>CIF Sale Price</td>
                          <td></td>
                          <td className="currency right">
                            {formatData(selectedGPOffer?.CIFSalePrice)}
                          </td>
                          <td className="currency right">
                            {formatData(
                              selectedGPOffer?.CIFSalePrice * INRToUsd
                            )}
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              )}

              {activeTab === "others" && (
                <div className="tab-content active">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="row">
                        <div className="col-lg-12">
                          <label htmlFor="additionalNotes">
                            Special Instruction for buyer
                          </label>
                          <textarea
                            id="additionalNotes"
                            value={
                              selectedGPOffer?.SpecialInstructionsBuyer || ""
                            }
                            className="form-control"
                            readOnly
                            rows="5"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </section>
          </div>

          {(activeTab === "offerInformation" || activeTab === "priceBreakup") &&
            selectedGPOffer &&
            (selectedGPOffer.OfferType === "Aggregated" ||
              (selectedGPOffer.SellerItemID &&
                selectedGPOffer.SellerItemID.includes("Aggregated"))) && (
              <div className="row">
                <label htmlFor="firstName" className="offers">
                  Seller Aggregate Details for Offer:{" "}
                  {selectedGPOffer.OfferSequenceID || "N/A"}
                </label>
                <section className="offers">
                  <table>
                    <thead>
                      <tr>
                        <th>Seller Type</th>
                        <th>Seller Name</th>
                        <th>State</th>
                        <th>Quantity (MT)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {gpOfferSellerAggregateItems &&
                        gpOfferSellerAggregateItems.map(
                          (gpOfferSellerAggregateItem) => (
                            <tr
                              key={gpOfferSellerAggregateItem.SellerItemID}
                              onClick={() =>
                                handleGPOfferSellerAggregateItemRowClick(
                                  gpOfferSellerAggregateItem
                                )
                              }
                              className={
                                selectedGPOfferSellerAggregateItem &&
                                selectedGPOfferSellerAggregateItem?.SellerItemID ===
                                  gpOfferSellerAggregateItem.SellerItemID
                                  ? "selected"
                                  : ""
                              }
                            >
                              <td>{gpOfferSellerAggregateItem.SellerType}</td>
                              <td>{gpOfferSellerAggregateItem.SellerName}</td>
                              <td>{gpOfferSellerAggregateItem.State}</td>
                              <td>{gpOfferSellerAggregateItem.Quantity}</td>
                            </tr>
                          )
                        )}
                      {gpOfferSellerAggregateItems.length === 0 && (
                        <tr>
                          <td colSpan="4">No aggregate items available</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <div className="pagination">
                    <button
                      onClick={() =>
                        handleGPOfferSellerAggregatePageChange(
                          currentGPOfferSellerAggregatePage - 1
                        )
                      }
                      disabled={currentGPOfferSellerAggregatePage === 1}
                    >
                      {"<"}
                    </button>
                    {Array.from(
                      { length: totalGPOfferSellerAggregatePages },
                      (_, index) => (
                        <button
                          key={index + 1}
                          onClick={() =>
                            handleGPOfferSellerAggregatePageChange(index + 1)
                          }
                          className={
                            currentGPOfferSellerAggregatePage === index + 1
                              ? "active"
                              : ""
                          }
                        >
                          {index + 1}
                        </button>
                      )
                    )}
                    <button
                      onClick={() =>
                        handleGPOfferSellerAggregatePageChange(
                          currentGPOfferSellerAggregatePage + 1
                        )
                      }
                      disabled={
                        currentGPOfferSellerAggregatePage ===
                        totalGPOfferSellerAggregatePages
                      }
                    >
                      {">"}
                    </button>
                  </div>
                </section>
              </div>
            )}
        </>
      )}
    </div>
  );
};

export default CreateOffersManual;
